import EncrptionInterceptor from "../lib/encryptionInterceptor";

const BASE_URL = "querymanager/insurance/web-requests";
const api = EncrptionInterceptor();

// Routed through kawachgateway_mw -> insurancex_mw, same as otpVerification.js.
// OTP is sent raw inside the encrypted body — insurancex_mw hashes and
// compares it server-side (otpHelper.js), so there's no client-side hashing
// step to replicate here.
export async function verifyOTP(mobile, otp) {
    const response = await api.post(`${BASE_URL}/verify-otp`, { channel: "MOBILE", mobile, otp });
    return response.data;
}

export async function verifyEmailOTP(email, otp) {
    const response = await api.post(`${BASE_URL}/verify-otp`, { channel: "EMAIL", email, otp });
    return response.data;
}
